module.exports = __webpack_public_path__ + "static/media/2.70e2139c.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row3/2.wav
// module id = 69
// module chunks = 0